import { render, staticRenderFns } from "./BookLogsMain.vue?vue&type=template&id=0725a0f4&scoped=true&"
import script from "./BookLogsMain.vue?vue&type=script&lang=js&"
export * from "./BookLogsMain.vue?vue&type=script&lang=js&"
import style0 from "./BookLogsMain.vue?vue&type=style&index=0&id=0725a0f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725a0f4",
  null
  
)

export default component.exports